import { PAYMENT_KEY, MODULES_KEY } from 'utils/constants'

export const setPaymentOverdueDate = invoiceDueDate => {
  localStorage.setItem(PAYMENT_KEY, invoiceDueDate)
}

export const getPaymentOverdueDate = () => {
  return localStorage.getItem(PAYMENT_KEY)
}

export const resetPaymentOverdueDate = () => {
  localStorage.setItem(PAYMENT_KEY, '')
}

export const setModules = modules => {
  localStorage.setItem(MODULES_KEY, JSON.stringify(modules))
}

export const getModules = () => {
  return localStorage.getItem(MODULES_KEY) ? JSON.parse(localStorage.getItem(MODULES_KEY)) : {}
}

export const removeModules = () => {
  localStorage.removeItem(MODULES_KEY)
}

export const removePaymentOverdueDate = () => {
  localStorage.removeItem(PAYMENT_KEY)
}
